import FlowActionButton from "@components/FlowActionButtons/FlowActionButton";
import { RESOLVE_DISPUTE_RESOLUTION_PERMISSION } from "@features/vessel-call/vessel-call-status/Operations/drawers/DisputeDetailsDrawer";

interface ResolveDisputeButtonProps {
  onClick?: () => void;
}

const LANG_BASE = "vessel-call.operations";

const ResolveDisputeButton = ({ onClick }: ResolveDisputeButtonProps) => {
  return (
    <FlowActionButton
      langBase={LANG_BASE}
      permission={RESOLVE_DISPUTE_RESOLUTION_PERMISSION}
      isActionAvailable
      labelKey="resolve-dispute-button"
      testId="operations-resolve-dispute-button"
      type="button"
      variant="contained"
      className="w-full whitespace-nowrap"
      onClick={() => onClick?.()}
    />
  );
};

export default ResolveDisputeButton;
